import React, { ReactNode } from 'react';

import { ErrorFallback } from '../../components/layouts/ErrorFallback';
import { logger } from '../../core/services/loggerService';

type Props = {
  children: ReactNode;
  identifier: string;
  shouldRenderFallbackUi?: boolean;
};

type State = {
  hasError: boolean;
};

export class ErrorBoundary extends React.Component<Props, State> {
  public constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  public static getDerivedStateFromError(): { hasError: boolean } {
    return { hasError: true };
  }

  public componentDidCatch(error, errorInfo): void {
    const { identifier } = this.props;
    logger.error(`${identifier} Error Boundary`, {
      message: error.message,
      stack: errorInfo.componentStack,
    });
  }

  public render(): ReactNode {
    const { children, shouldRenderFallbackUi = false } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return shouldRenderFallbackUi ? <ErrorFallback /> : null;
    }

    return children;
  }
}
